const RouteNames = {
  "/": "Můj Dashboard",

  "/userManagement": "Správa uživatelů",
  "/signIn": "Přihlášení",
  "/signUp": "Registrace",
  "/user": "Uživatelský účet",
  "/user/editContact": "Upravit kontaktní údaje",
  "/user/editProfile": "Upravit profil uživatele",

  "/races": "Závody",
  "/races/detail": "Detail závodu",
  "/races/create": "Nový závod",
  "/races/merchandise": "Doplňkové služby závodu",

  "/merchandise": "Doplňkové služby",
  "/merchandise/create": "Nová doplňková služba",
  "/merchandise/update": "Upravit doplňkovou službu",

  "/vouchers": "Vouchery",

  "/masters": "Masters",

  "/register/new": "Registrace do závodu",
  "/register/detail": "Registrace do závodu",
  "/team/detail": "Tým",
  "/register/edit": "Úprava registrace",
  "/register/voucher": "Registrace s voucherem",
  "/register/paid": "Registrace - Platba poplatku",
  "/register/sudoEdit": "Administrace - Úprava registrace",
  "/register/editContact": "Upravit kontaktní údaje",
  "/register/startList": "Startovní listina",
  "/team/startList": "Startovní listina",

  "/accreditation": "Akreditace",

  "/photos": "Správa fotek",
  "/gallery": "Fotogalerie",

  "/support": "Podpora",
};

export default RouteNames;
